import { Component, OnInit } from '@angular/core';
import { LogoService } from '../data/logo.service';
import '../../../assets/js/smtp.js';
//import { client } from 'elasticemail-webapiclient';
declare let Email: any;

@Component({
  selector: 'app-contact-us',
  templateUrl: './contact-us.component.html',
  styleUrls: ['./contact-us.component.css']
})
export class ContactUsComponent implements OnInit {

  data: any;
  inputData: any;
  body :string;
  showform:boolean;

  constructor(private logos: LogoService) { 
	
	this.inputData ={};
	this.showform =true;
	this.body =" <tr>\r\n          <td valign=\"top\" align=\"center\" bgcolor=\"#0d1121\" style=\"padding:35px 70px 30px;\" class=\"em_padd\"><table align=\"center\" width=\"100%\" border=\"0\" cellspacing=\"0\" cellpadding=\"0\">\r\n              <tr>\r\n                <td height=\"25\" class=\"em_h20\" style=\"font-size:0px; line-height:0px; height:25px;\">&nbsp;<\/td>\r\n              <\/tr>\r\n            <tr>\r\n                <td align=\"center\" valign=\"top\" style=\"font-family:'Open Sans', Arial, sans-serif; font-size:18px; line-height:22px; color:#fbeb59; text-transform:uppercase; letter-spacing:2px; padding-bottom:12px;\"> Name : =name= <\/td>\r\n            <\/tr>\r\n            <tr>\r\n                <td height=\"25\" class=\"em_h20\" style=\"font-size:0px; line-height:0px; height:25px;\">&nbsp;<\/td>\r\n            <\/tr>\r\n            <tr>\r\n                <td align=\"center\" valign=\"top\" style=\"font-family:'Open Sans', Arial, sans-serif; font-size:18px; line-height:22px; color:#fbeb59; text-transform:uppercase; letter-spacing:2px; padding-bottom:12px;\"> Email : =email= <\/td>\r\n            <\/tr>\r\n            <tr>\r\n                <td height=\"25\" class=\"em_h20\" style=\"font-size:0px; line-height:0px; height:25px;\">&nbsp;<\/td>\r\n            <\/tr>\r\n            <tr>\r\n                <td align=\"center\" valign=\"top\" style=\"font-family:'Open Sans', Arial, sans-serif; font-size:18px; line-height:22px; color:#fbeb59; text-transform:uppercase; letter-spacing:2px; padding-bottom:12px;\"> Phone : =phone= <\/td>\r\n            <\/tr>\r\n            <tr>\r\n                <td height=\"25\" class=\"em_h20\" style=\"font-size:0px; line-height:0px; height:25px;\">&nbsp;<\/td>\r\n            <\/tr>\r\n            <tr>\r\n                <td align=\"center\" valign=\"top\" style=\"font-family:'Open Sans', Arial, sans-serif; font-size:18px; line-height:22px; color:#fbeb59; text-transform:uppercase; letter-spacing:2px; padding-bottom:12px;\"> Message : =message= <\/td>\r\n            <\/tr>\r\n            <\/table><\/td>\r\n        <\/tr>";
}


  emailParams: any;
	

  ngOnInit(): void {
    this.getData();
  }

  getData(): void {
    this.logos.getLogoData().subscribe( data => this.data = data );
  }

  sendEmail(): void {
	console.log(this.inputData );
	this.body = this.body.replace("=name=",(this.inputData.firstname +' '+ this.inputData.lastname)  );
	this.body = this.body.replace("=email=",this.inputData.email);
	this.body = this.body.replace("=phone=",this.inputData.phone);
	this.body = this.body.replace("=message=",this.inputData.message);
		
		Email.send({
		    Host : "smtp.elasticemail.com",
		    Username : "trishul.techltd@gmail.com",
		    Password : "73DD4DE722D332A5369D5AFED11ECCA10725",
		    To : 'dineshkumar003@gmail.com,gokul@freedomfinancialservices.co.uk,krishna@freedomfinancialservices.co.uk',
		    From : "trishul.techltd@gmail.com",
		    Subject : "Freedom Circle Website Contact",
		    Body : this.body
		}).then(
		);
	
	this.showThankyou();
	
  }

showThankyou(): void {
	this.showform =false;
}

}
